<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
	name: 'ToStep'
});
</script>
<template>
	<div class="to-step" :flex="flex ? flex : null" :class="setClass">
		<template v-for="(item, idx) in data_" :key="idx">
			<div class="to-step-item" :class="{ 'is-on': idx === Number(modelValue), 'is-completed': Number(modelValue) > idx }" @click="itemClick(item, idx)">
				<div class="to-step-item-content">
					<div class="to-step-item-header">
						<slot name="header" :item="item" :index="idx">
							<div class="to-step-item-icon">
								<template v-if="item.icon">
									<to-icon :value="item.icon"></to-icon>
								</template>
								<template v-else>
									<div v-if="Number(modelValue) > idx" class="to-step-item-icon-content"></div>
									<div v-else class="to-step-item-number">{{ idx + 1 }}</div>
								</template>
							</div>
							<div class="to-step-item-text">
								<div class="to-step-item-title">
									<div class="to-step-item-title-text">{{ item.title }}</div>
								</div>
								<div v-if="item.desc || $slots.desc" class="to-step-item-desc">
									<div class="to-step-item-desc-text">
										<slot name="desc" :item="item" :index="idx">{{ item.desc }}</slot>
									</div>
								</div>
							</div>
						</slot>
					</div>
					<div v-if="item.detail || $slots.default" class="to-step-item-detail">
						<div class="to-step-item-detail-text">
							<slot :item="item" :index="idx">{{ item.detail }}</slot>
						</div>
					</div>
				</div>
				<div v-if="idx !== data_.length - 1 && dir === 'v'" class="to-step-divider"></div>
			</div>
			<div v-if="idx !== data_.length - 1 && !dir" class="to-step-divider"></div>
		</template>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue'



export interface ItemProps {
	title: string
	desc?: string
	detail?: string
	icon?: string
}

const props = defineProps({
	data: {
		type: [Array as () => ItemProps[], String],
		default: ''
	},
	modelValue: { type: [Number, String], default: 0 },
	mode: { type: String, default: 'default' },
	dir: { type: String, default: '' },
	itemDir: { type: String, default: '' },
	flex: { type: Boolean, default: false }
})
const setClass = computed(() => {
	let arr: string[] = []
	if (props.mode) {
		arr.push(`mode-${props.mode}`)
	}
	if (props.dir) {
		arr.push(`dir-${props.dir}`)
	}
	if (props.itemDir) {
		arr.push(`item-dir-${props.itemDir}`)
	}
	return arr
})

const data_ = computed(() => {
	let arr: ItemProps[] = []
	if (props.data) {
		if (typeof props.data === 'string') {
			arr = props.data.split(',').map(item => ({ title: item }))
		} else {
			arr = props.data
		}
	}
	return arr
})

const emit = defineEmits<{
	(e: 'update:modelValue', value: number): void
	(e: 'item-click', item: ItemProps, index: number): void
}>()

const updateValue = (idx: number) => {
	emit('update:modelValue', idx)
}
defineExpose({
	updateValue
})
const itemClick = (item, idx) => {
	emit('item-click', item, idx)
}
</script>
